import L from 'leaflet';
import * as LO from 'leaflet.offline';
import { getTileUrls, downloadTile, saveTile } from 'leaflet.offline';

export class MapPreloader {

    map = null;
    urlTemplate = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    baseLayer;
    private static instance;

    private constructor() { }

    public static getInstance(): MapPreloader {
        if (!MapPreloader.instance) {
            MapPreloader.instance = new MapPreloader();
        }
        return MapPreloader.instance;
    }

    control;
    loadLeafletMaps() {
        return new Promise<any>((resolve, reject) => {
            let map = MapPreloader.getInstance().map;

            if (map) {
                this.map.off();
                this.map.remove();
                this.map = null;
            }

            this.map = (L as any).map('leafmap');

            MapPreloader.getInstance().baseLayer = (L as any).tileLayer
                .offline(this.urlTemplate, {
                    attribution: 'Map data {attribution.OpenStreetMap}',
                    subdomains: 'abc',
                    minZoom: 1,
                })
                .addTo(MapPreloader.getInstance().map);

            MapPreloader.getInstance().map.setView(
                {
                    lat: 52.5204345,
                    lng: 13.4014027,
                },
                16
            );
            // let options = {
            //     zoomlevels: [18, 18],
            //     confirm: this.confirm
            // }

            let that = this;
            // add buttons to save tiles in area viewed
            MapPreloader.getInstance().control = (L as any).control.savetiles(this.baseLayer, {
                zoomlevels: [16, 16], // optional zoomlevels to save, default current zoomlevel
                // confirm: this.confirm,
                confirm(layer, successCallback) {
                    // console.log('successCallback: ', successCallback);
                    console.log('layer: ', layer);
                    successCallback();
                },
                confirmRemoval(layer, successCallback) {
                    // eslint-disable-next-line no-alert
                    if (window.confirm('Remove all the tiles?')) {
                        successCallback();
                    }
                },
                saveText:
                    '<i class="fa fa-download" aria-hidden="true" title="Save tiles"></i>',
                rmText: '<i class="fa fa-trash" aria-hidden="true"  title="Remove tiles"></i>',
            });
            MapPreloader.getInstance().control.addTo(this.map);

            let progress;
            MapPreloader.getInstance().baseLayer.on('savestart', (e) => {
                console.log('e: ', e);
                progress = 0;
                console.log(e._tilesforSave.length);
            });
            MapPreloader.getInstance().baseLayer.on('savetileend', () => {
                progress += 1;
                console.log("progress: " + progress);
            });

            // console.log('control: ', this.control._baseLayer._events.savestart[0].fn());
            resolve(null);
        });
    }

    preloadMap(path): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            let time = 200;
            let i = 0;

            let timer = setInterval(() => {
                MapPreloader.getInstance().map.setView(new L.LatLng(path[i].lat(), path[i].lng()));
                i += 2;

                if (i >= path.length) {
                    clearInterval(timer);
                    resolve(null);
                }
            }, time);
        });
    }

    path = [];
    saveTile() {
        let points = this.path.map(coords => L.point(coords.lat, coords.lng));
        let bounds = L.bounds(points);
        let urls = getTileUrls(this.baseLayer, bounds, 16);
        for (let i = 0; i < urls.length; i++) {
            downloadTile(urls[i].url).then(blob => {
                saveTile(urls[i], blob).then(() => {
                    console.log('tile saved: ' + urls[i].url);
                });
            });
        }
    }

    successCallback() {
        console.log('success!');
    }

    setMapCenter(lat, lng) {
        let coords = { lat: lat, lng: lng };
        this.path.push(coords);
        MapPreloader.getInstance().map.setView(new L.LatLng(lat, lng), 16);
    }
}


// WEBPACK FOOTER //
// /src/tracker/map-factory/map-preloader.ts